// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"styles_socialLinks__2GUpq"};